import { SectionTitle } from "@/components/molecules";
import { Icon } from "@/components/atoms";

const Section = ({ id, title, icon }) => {
  return (
    <div className={`flex items-center ${id !== "mxn" ? "sc-border" : ""}`}>
      {icon && (
        <Icon
          className="pr-2 pt-2"
          alt={icon.alt}
          icon={icon.name}
          size={icon.size || "small"}
        />
      )}
      <SectionTitle id={id} label={title} />
    </div>
  );
};

export default Section;